import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";
import checkIcon from "../../../resources/images/check-white.svg";
import checkIconRed from "../../../resources/images/alert-circle.svg";

const styles = createUseStyles((theme) => ({
  overrideDiscountTierModal: {
    width: "480px",
    height: "550px",
    maxHeight: "550px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex",
        },
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px",
      },
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
      marginBottom: "8px",
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
    },
    "& .modal-body": {
      padding: "0px 24px 24px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
    },
  },
  overrideDiscountTierModalWrapper: {
    //backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContent: {
    margin: "20px 0 0 0",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "268px",
    width: "100%",
    padding: "2px",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },

  btnContainer: {
    marginTop: "32px",
  },
  btnsRow: {
    flexWrap: "nowrap",
  },
  cancelBtn: {
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "20px",
    fontFamily: theme.fontFamily,
    height: "100%",
    alignItems: "center",
  },
  chooseBtn: {
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "20px",
    fontFamily: theme.fontFamily,
  },
  colCancel: {
    padding: "0px",
    marginRight: "12px",
  },
  colChoose: {
    padding: "0px",
  },
  optionContainer:{
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    border: "1px solid " + colors.lightGrey,
    borderRadius: "12px",
    padding: "16px",
    marginBottom:"12px",
    alignItems:"center",
    "&:hover": {
      border: theme.modal.optionHover.border,
      "& input":{
        backgroundColor: theme.modal.optionHover.backgroundColor,
        border: theme.buttons.primary.border,
        "&:checked": {
          backgroundColor: theme.modal.backgroundColor,
          border: theme.modal.border,
          outline: theme.buttons.primary.border,
          borderColor: theme.modal.optionHover.backgroundColor
        }
      },
    },
    "& h3":{
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      color: colors.grey,
      margin: 0
    },
    "& p":{
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: colors.grey,
      marginLeft: "8px",
      margin:"0px"
    },
    "& input":{
      appearance: "none",
      width: "16px",
      height: "16px",
      border: "1px solid " + colors.lightGrey,
      borderRadius: "8px",
      cursor: "pointer",
      "&:checked": {
        backgroundColor: theme.modal.backgroundColor,
        border: theme.modal.border,
        outline: theme.buttons.primary.border,
        backgroundImage: "none",
      }
    },
  },
  selectedOptionContainer:{
    border: theme.modal.selectedOption.border,
    backgroundColor: theme.modal.selectedOption.backgroundColor,
    color: theme.modal.selectedOption.text.color,
    padding: "15px",
    "&:hover": {
      border: theme.modal.selectedOption.border,
    },
    "& h3":{
      color: theme.modal.selectedOption.text.color,
    },
    "& p":{
      color: theme.modal.selectedOption.text.color,
    },
  },
  inputContainer: {
    marginBottom: "20px",
    display: "flex",
    flexDirection: "column",
    "& input": {
      height: "44px",
      width: "100%",
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      padding: "10px 14px",
      "&:focus": {
        outline: "none",
      },
      "&:disabled": {
        cursor: "default",
        backgroundColor: "rgba(239, 239, 239, 0.3)",
        color: "rgb(84, 84, 84)",
        borderColor: "rgba(118, 118, 118, 0.3)",
      },
    },
    "& .input-error": {
      border: "1px solid " + colors.mediumRed,
      backgroundSize: "16px 16px",
      backgroundPosition: "right",
      backgroundRepeat: "no-repeat",
      backgroundOrigin: "content-box",
      backgroundImage: `url(${checkIconRed})`,
    },
  },
  error: {
    color: colors.red,
    fontSize: "14px",
    textAlign: "left",
    "& p": {
      margin: 0,
    },
  },
  requiredError: {
    fontSize: "14px",
    fontWeight:"400",
    color: colors.red,
    marginTop: "6px"
  },

}));

export default styles;
